/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { WebProvisionCredentialInfoRequest } from '../../models/web-provision-credential-info-request';
import { WebProvisionCredentialInfoResponse } from '../../models/web-provision-credential-info-response';

export interface InfoCredentialRedemption$Params {
      body: WebProvisionCredentialInfoRequest
}

export function infoCredentialRedemption(http: HttpClient, rootUrl: string, params: InfoCredentialRedemption$Params, context?: HttpContext): Observable<StrictHttpResponse<WebProvisionCredentialInfoResponse>> {
  const rb = new RequestBuilder(rootUrl, infoCredentialRedemption.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<WebProvisionCredentialInfoResponse>;
    })
  );
}

infoCredentialRedemption.PATH = '/webprovision/info';
